import(/* webpackMode: "eager", webpackExports: ["Category"] */ "/app/src/screens/Category/ui/Category.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/shkaf-napolnyi.png");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/shkaf-pod-stiralku.png");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/shkaf-podvesnoi.png");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/tumba_pod_stiralku.png");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/tumba-napolnaya.png");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/tumba-navesnaya.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/tumba-s-rakovinoi.png");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/zerkala-s-podsvetkoi.png");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/CategoriesMenu/images/zerkalnui-shkaf.png");
